import React from "react";
import { string } from "prop-types";

import "./sponsored.m.css";

const Sponsored = ({ fontColor = "#0572E6", bgColor = "#E3F2FD", className = "" }) => (
  <svg styleName="icon" className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
    <circle cx="15.999" cy="16" r="13.333" fill={bgColor} />
    <path
      d="m12.016 13.206-2.363-.002a2.03 2.03 0 0 0-2.167 2.168v.147a2.03 2.03 0 0 0 2.167 2.167l2.363.002v-4.482zM22.533 10.65a.608.608 0 0 0-.417.184l-1.18 1.18a.61.61 0 0 0 .153.999.61.61 0 0 0 .703-.139l1.18-1.18a.607.607 0 0 0-.44-1.044zM22.477 14.656a.609.609 0 0 0 .062 1.215h1.67a.609.609 0 0 0 .026-1.216l-.027.001H22.54a.463.463 0 0 0-.062 0zM21.36 17.476c-.02 0-.042 0-.063.002a.61.61 0 0 0-.359 1.041l1.18 1.18a.609.609 0 1 0 .858-.857l-1.18-1.18a.61.61 0 0 0-.435-.186zM19.55 20.666v-10.44a.689.689 0 1 0-1.379 0 8.218 8.218 0 0 1-4.957 2.853l.035 4.747a8.193 8.193 0 0 1 4.925 2.843.69.69 0 0 0 1.38 0l-.004-.003zM12.356 20.884l-.549-2.167-2.231.032.678 2.672a1.084 1.084 0 0 0 2.1-.533l.002-.004z"
      fill={fontColor}
    />
  </svg>
);

Sponsored.propTypes = {
  fontColor: string,
  bgColor: string,
  className: string,
};

export default Sponsored;
